<template>
  <div class="filters-wrapper">
    <button class="btn btn-primary" @click="showEditOrderModal(null)">Создать заказ</button>

    <div class="filters-group">
      <argon-input
          placeholder="Поиск"
          v-model="searchOrderName"
          @keyup.enter="fetchOrders"
      />

      <div class="filter-item">
        <label>Сезон:</label>
        <select v-model="sezon">
          <option value=""></option>
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>Выдача:</label>
        <input type="date" v-model="arendaOrderStart" />
        <input type="date" v-model="arendaOrderEnd" />
      </div>

      <div class="filter-item">
        <label>Возврат:</label>
        <input type="date" v-model="filterOrderByDateStart" />
        <input type="date" v-model="filterOrderByDate" />
      </div>

      <div class="filter-item">
        <label>Статус:</label>
        <select v-model="filterStatusId">
          <option :value="0">Все</option>
          <option :value="1">Бронь</option>
          <option :value="2">Активный</option>
          <option :value="3">Выполнен</option>
        </select>
      </div>

      <button class="btn btn-primary" @click="fetchOrders">
        Применить
      </button>

      <button class="btn btn-primary" @click="fetchOverdue">
        Просрочено
      </button>
    </div>
  </div>
  <div class="card container-fluid">
    <div class="card-header pb-0">
      <h6>Заказы <span v-if="totalCount">({{ totalCount }})</span> на сумму {{ summ }}</h6>
    </div>

    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">ID</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Статус</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Залог</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Клиент</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Выдача</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Возврата</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Юр</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Оплачено</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">Товары</th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">События|Документы</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in orders" :key="order.id" :class="getRowClass(order)" style="font-size: 12px !important;">
            <td>{{ order.id }}</td>
            <td>{{ getStatusName(order.status) }}</td>
            <td>{{ order.securityDepositAmount.toFixed(2) }} BYN</td>
            <td
                style="cursor: pointer"
                v-if="order.client.clientId"
                @click="openClientModal(order.client.clientId)"
            >
              {{ order.client.clientName }}
            </td>
            <td v-else>—</td>
            <td>{{ formatDate(order.rentStartDate) }} {{ order.timeRentStart }}</td>
            <td>{{ formatDate(order.rentEndDate) }}</td>
            <td>
              <CustomCheckBox :value="order.client.isLegalEntity"/>
            </td>
            <td>
              <div :class="getItemClass(Number(order.endPrice - order.oplacheno))">
                {{ Number(order.endPrice - order.oplacheno).toFixed(2) }} BYN
              </div>
            </td>
            <td>
              <button class="btn btn-sm btn-success" @click="showOrderInfoModal(order.id)">Детали</button>
            </td>
            <td>
              <a href="javascript:;" @click="showEditOrderModal(order)">
                <i class="fas fa-edit text-primary"></i>
              </a>
              <a style="margin-left: 15px" href="javascript:;" @click="confirmDeleteOrder(order)">
                <i class="fas fa-trash"></i>
              </a>
              <b style="margin-left: 15px"> | </b>
              <a style="margin-left: 15px" href="javascript:;" @click="downloadContract(order.id)">
                <i class="fas fa-print"></i>
              </a>
              <a style="margin-left: 15px" href="javascript:;" @click="downloadActPriemPeredach(order.id)">
                <i class="fas fa-file"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-2 d-flex justify-content-between align-items-center">
        <button class="btn btn-secondary btn-sm" :disabled="page === 1" @click="prevPage">Назад</button>
        <span>Страница {{ page }} из {{ totalPages }}</span>
        <button class="btn btn-secondary btn-sm" :disabled="page === totalPages" @click="nextPage">Вперед</button>
      </div>
    </div>

    <ShowProductAdditionalInfo
        v-if="selectedOrder"
        :order="selectedOrder"
        @close="selectedOrder = null"
    />

    <ClientFormModal
        :show="showClientModal"
        :client-id="selectedClientId"
        @close="closeClientModal"
        @saved="onClientSaved"
    />

    <OrderEditorModal
        :show="showOrderModal"
        :order-id="editingOrderId"
        @close="closeOrderModal"
        @saved="onOrderSaved"
    />

    <OrderInfoModal
        :show="showOrderInfoModalFlag"
        :order-id="viewOrderId"
        @close="showOrderInfoModalFlag = false"
    />
  </div>
</template>

<script>
import axios from "@/axios";
import ShowProductAdditionalInfo from "../ProductComponents/ShowProductAdditionalInfo.vue";
import CustomCheckBox from "@/views/components/CustomCheckBox.vue";
import ClientFormModal from "@/views/components/Form/ClientFormModal.vue";
import OrderEditorModal from "@/views/components/Form/OrderEditorModal.vue";
import OrderInfoModal from "@/views/components/Form/OrderInfoModal.vue"
import '@/assets/css/OrdersTable.css';
import ArgonInput from "@/components/ArgonInput.vue";

export default {
  name: "OrderProductsTable",
  components: {
    ArgonInput,
    CustomCheckBox,
    OrderInfoModal,
    ShowProductAdditionalInfo,
    ClientFormModal,
    OrderEditorModal
  },
  props: {
    orderId: Number,
    perPage: { type: Number, default: 20 },
  },

  data() {
    return {
      orders: [],
      page: 1,
      totalCount: 0,
      totalPages: 1,
      selectedOrder: null,
      showClientModal: false,
      isShowOrderInfoModal: false,
      showOrderInfoModalFlag: false,
      viewOrderId: null,
      selectedClientId: null,
      showOrderModal: false,
      editingOrderId: null,
      isDeleting: false,
      summ: 0,
      years: [],

      searchOrderName: "",
      filterStatusId: 0,
      filterOrderByDateStart: null,
      filterOrderByDate: null,
      arendaOrderStart: null,
      arendaOrderEnd: null,
      sezon: null,
    };
  },

  mounted() {
    this.fetchSezones();
    this.fetchOrders();
  },

  methods: {
    fetchSezones() {
      axios.get('/api/order/get-sezones')
          .then(res => {
            this.years = res.data;
          });
    },
    openClientModal(clientId) {
      this.selectedClientId = clientId;
      this.showClientModal = true;
    },

    closeClientModal() {
      this.showClientModal = false;
      this.selectedClientId = null;
    },

    showEditOrderModal(order) {
      this.editingOrderId = order?.id;
      this.showOrderModal = true;
    },

    closeOrderModal() {
      this.showOrderModal = false;
      this.editingOrderId = null;
    },

    onOrderSaved() {
      this.closeOrderModal();
      this.fetchOrders();
    },

    getItemClass(val) {
      if (val > 0) return 'red';
      else if (val < 0) return 'green';
      return 'black';
    },

    onClientSaved() {
      this.fetchOrders();
    },

    fetchOrders() {

      let url = `/api/order/orders?page=${this.page}&perPage=${this.perPage}`;

      if (this.filterStatusId && this.filterStatusId != 0)
        url += `&status=${this.filterStatusId}`;

      if (this.searchOrderName && this.searchOrderName.length >= 3)
        url += `&search=${this.searchOrderName}`;

      if (this.filterOrderByDateStart)
        url += `&datestart=${this.filterOrderByDateStart}`;

      if (this.filterOrderByDate)
        url += `&date=${this.filterOrderByDate}`;

      if (this.arendaOrderStart)
        url += `&arendastartot=${this.arendaOrderStart}`;

      if (this.arendaOrderEnd)
        url += `&arendastartdo=${this.arendaOrderEnd}`;

      if (this.sezon)
        url += `&sezon=${this.sezon}`;

      axios.get(url).then(res => {

        const data = res.data;

        this.orders = data.orders.map(order => ({
          ...order,
          client: order.client
              ? {
                clientId: order.client.clientId,
                clientName: order.client.clientName,
                isLegalEntity: order.client.isLegalEntity
              }
              : {
                clientId: null,
                clientName: "Клиент не найден",
                isLegalEntity: false
              }
        }));

        this.totalCount = data.count;
        this.summ = data.summ;
        this.totalPages = Math.ceil(data.count / this.perPage);
      });
    },

    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchOrders();
      }
    },

    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.fetchOrders();
      }
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" });
    },

    getStatusName(status) {
      if (status === 1) return "Бронь";
      if (status === 2) return "Активный";
      if (status === 3) return "Выполнен";
      return "-";
    },
    fetchOverdue() {

      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      this.filterOrderByDate = yesterday.toISOString().slice(0, 10);
      this.filterStatusId = 2;

      this.page = 1;

      this.fetchOrders();
    },
    showOrderInfoModal(orderId) {
      this.viewOrderId = orderId
      this.showOrderInfoModalFlag = true
    },

    downloadContract(orderId) {
      axios.get(`/api/order/${orderId}/generate-legal-contract`, { responseType: 'blob' })
          .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `contract_${orderId}.docx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
    },

    downloadActPriemPeredach(orderId) {
      axios.get(`/api/order/${orderId}/generate-act-priem-peredach`, { responseType: 'blob' })
          .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `act_priem_peredach_${orderId}.docx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
    },

    getRowClass(item) {
      if ('qty' in item && Number(item.dostupno) <= 0) {
        return 'bg-red';
      } else if ('qty' in item && Number(item.dostupno) < 5) {
        return 'bg-yellow';
      } else if (item.status === 1) {
        return 'bg-blue';
      } else if (item.status === 2) {
        return 'bg-red';
      } else if (item.status === 3) {
        return 'bg-green';
      } else if (item.blackList != null) {
        return 'bg-red';
      }
      return '';
    },

    async confirmDeleteOrder(order) {
      if (this.isDeleting) {
        return;
      }

      if (!confirm(`Удалить заказ #${order.id}?`)) {
        return;
      }

      this.isDeleting = true;

      try {
        await axios.delete(`/api/order/${order.id}`);

        if (this.orders.length === 1 && this.page > 1) {
          this.page -= 1;
        }

        this.fetchOrders();
      } catch (error) {
        console.error("Ошибка удаления заказа:", error);
        alert("Не удалось удалить заказ");
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>

<style scoped>
.date-block {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  max-width: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
td {
  color: black;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 0px 5px !important;
}
.date-group {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 32px;
  margin-left: 15px;
  margin-right: 15px;
}

.date-input {
  display: flex;
  align-items: center;
}

.date-label {
  margin-right: 10px;
}

.date-group-name {
  margin-left: 35px;
}
.filters-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.filters-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
  flex: 1;
}

.filter-item {
  display: flex;
  flex-direction: column;
  min-width: 120px;
}

.filter-item input,
.filter-item select,
.search-input {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.4rem 0.6rem;
  font-size: 0.85rem;
}

.filter-item label {
  font-weight: 600;
  margin-bottom: 4px;
}

.search-input {
  min-width: 180px;
  flex: 1 1 180px;
}

.filters-group button {
  margin-left: 5px;
  height: 38px;
}
</style>